import { useEffect, useState } from 'react';

import { Button, Card } from '@lilith-arcana-os/ui';
import { useMutation, useQuery } from '@tanstack/react-query';

import type { UserPreferences } from '@lilith-arcana-os/domain';

import { SettingsForm } from '../components/settings/SettingsForm';
import { PageHeader } from '../components/ui/PageHeader';
import { apiClient } from '../lib/api-client';
import { useAppStore } from '../stores/app-store';
import { useUserStore } from '../stores/user-store';

export function SettingsPage() {
  const setPreferences = useUserStore((state) => state.setPreferences);
  const preferences = useUserStore((state) => state.preferences);
  const setLlmStatus = useAppStore((state) => state.setLlmStatus);
  const [draft, setDraft] = useState<UserPreferences>(preferences);
  const [healthMessage, setHealthMessage] = useState<string>('');

  const settingsQuery = useQuery({
    queryKey: ['settings'],
    queryFn: apiClient.settings,
  });

  useEffect(() => {
    if (settingsQuery.data) {
      setPreferences(settingsQuery.data.preferences);
      setDraft(settingsQuery.data.preferences);
    }
  }, [setPreferences, settingsQuery.data]);

  const saveMutation = useMutation({
    mutationFn: () => apiClient.saveSettings(draft),
    onSuccess: (response) => {
      setPreferences(response.preferences);
      setDraft(response.preferences);
    },
  });

  const healthMutation = useMutation({
    mutationFn: apiClient.llmHealth,
    onSuccess: (response) => {
      setHealthMessage(response.error ?? 'Provider raggiungibile.');
      setLlmStatus(response.connected ? 'ready' : 'fallback');
    },
    onError: () => {
      setHealthMessage('Provider non raggiungibile.');
      setLlmStatus('fallback');
    },
  });

  return (
    <div className="space-y-6">
      <PageHeader
        badge="Settings"
        description="Preferenze utente in user meta, configurazione plugin in Options API e stato provider separato."
        eyebrow="Impostazioni"
        title="Preferences and providers"
      />

      <SettingsForm
        isSaving={saveMutation.isPending}
        onChange={setDraft}
        onSubmit={() => void saveMutation.mutate()}
        preferences={draft}
      />

      <Card eyebrow="Provider" title="LLM health">
        <div className="flex flex-wrap items-center gap-3">
          <Button onClick={() => void healthMutation.mutate()} variant="secondary">
            Test provider
          </Button>
          <p className="text-sm text-[var(--la-text-muted)]">
            {healthMessage || 'Esegui il test sulla route `/llm/health`.'}
          </p>
        </div>
      </Card>
    </div>
  );
}
